
import { mapGetters } from "vuex";
import vClickOutside from "v-click-outside";
import ReviewItem from "~/components/v2/review-item.vue";
import { mdiCheck } from "@mdi/js";

export default {
  name: "Reviews",

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    ReviewItem,
  },

  data() {
    return {
      loading: false,
      timeoutId: null,
      gender: null,
      district: "",
      mdiCheck,
    };
  },

  async fetch() {
    try {
      this.gender = this.$store.getters["global/getCurrentGender"] || "female";
      this.$store.commit("reviews/setFilter", {
        key: "gender",
        value: this.gender,
      });
      await this.$store.dispatch("reviews/getAllReviews", 1);
    } catch (e) {
      console.log(e);
    }
  },

  head() {
    return {
      title: this.seoTexts?.title || "Reviews",

      link: [
        {
          rel: "canonical",
          href: `${this.$config.baseUrlApp}/reviews`,
        },
      ],

      meta: [
        {
          hid: "description",
          name: "description",
          content:
            this.seoTexts?.description ||
            "We bring to your attention only the best and proven models. Be confident in quality and efficiency",
        },
        {
          hid: "og:description",
          name: "og:description",
          content:
            this.seoTexts?.description ||
            "We bring to your attention only the best and proven models. Be confident in quality and efficiency",
        },
        {
          hid: "og:title",
          name: "og:title",
          content: this.seoTexts?.title || "Reviews",
        },
        {
          property: "og:image",
          hid: "og:image",
          name: "og:image",
          content: "https://erowall.com/wallpapers/large/3156.jpg",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      isMobile: "global/getMobileStatus",
      reviews: "reviews/getAllReviews",
      currentPage: "reviews/getCurrentPage",
      lastPage: "reviews/getLastPage",
      total: "reviews/getTotal",
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
      seoTexts: "global/getSeoTexts",
    }),

    h1() {
      return this.seoTexts?.h1 || this.$t("nav.reviews");
    },

    isLastPage() {
      return this.currentPage > this.lastPage;
    },

    reviewsNumber() {
      return this.reviews.length;
    },

    percentage() {
      return (this.reviewsNumber / this.total) * 100;
    },

    filterObj() {
      const districts =
        this.filtersList?.districts?.filter(
          (district) => district.city_id == this.currentCity.id
        ) || [];
      return {
        district: {
          items: districts,
          title: this.$t("area"),
        },
        gender: {
          items: [
            { title: this.$t("female"), id: "female" },
            { title: this.$t("shemale"), id: "transgender" },
            { title: this.$t("male"), id: "male" },
          ],
          title: this.$t("gender"),
        },
      };
    },

    districtsDroplist() {
      return [
        ...[
          {
            title: this.$t("all-areas"),
            value: "",
          },
        ],
        ...(this.filterObj.district.items?.map((item) => {
          return {
            title: item.title,
            value: item.id,
          };
        }) || []),
      ];
    },

    genderDroplist() {
      return (
        this.filterObj.gender.items?.map((item) => {
          return {
            title: item.title,
            value: item.id,
          };
        }) || []
      );
    },
  },

  beforeDestroy() {
    this.resetFilters();
  },

  methods: {
    apply() {
      this.$store.dispatch("reviews/getAllReviews", this.currentPage);
      this.$store.commit("global/setCommentsFilter");
    },

    async showMoreReviews() {
      this.loading = true;
      try {
        await this.$store.dispatch("reviews/getAllReviews", this.currentPage);
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    openMobileFilters() {
      this.$store.commit("global/setCommentsFilter");
    },

    setFilter(key, value) {
      console.log("Setting filter:", key, value);
      const _key = key === "name" ? "searchText" : key;
      let _value = value;
      if (value?.value) {
        _value = value.value;
      }

      this.$store.commit("reviews/setFilter", {
        key: _key,
        value: _value,
      });
      this.$store.dispatch("reviews/getAllReviews");
    },

    textSearch(key, value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.setFilter(key, value);
      }, 500);
    },

    resetFilters() {
      this.$store.commit("reviews/resetFilters");
      this.$store.dispatch("reviews/getAllReviews");
      this.$store.commit("global/setCommentsFilter");
    },

    setFilterMobile(data) {
      for (let key in data) {
        const value = data[key];
        if (value) {
          this.$store.commit("reviews/setFilter", { key, value });
        }
      }
    },
  },
};
